import React from "react";
import Lottie from "lottie-web";
import Animation from "../../../../../static/animations/hero-zmt.json";

export default function HeroZmtMobile() {
  React.useEffect(() => {
    Lottie.loadAnimation({
      container: document.querySelector("#hero-animation-bg-mobile"),
      animationData: Animation,
      renderer: "svg", // "canvas", "html"
      loop: true, // boolean
      autoplay: true, // boolean
    });
  }, []);

  return (
    <>
      <div id="hero-animation-bg-mobile" />
      <div id="coin-zmt" />
    </>
  );
}
